import { SAILS_BNT_STORAGE, SAILS_PARAM_TRADE_IN } from '@vfde-fe/sails-constants';
import { getSessionStorage } from '@vfde-fe/sails_core';
import { APP, CONTAINER_TARIFF } from '../../../constants';

/**
 * Get trade in
 * If this func returns true, it means that trade-in switch is on and a device is selected
 */
export const getTradeIn = (): boolean => {
    const sailsBntStorage = getSessionStorage(SAILS_BNT_STORAGE);

    return !!sailsBntStorage[SAILS_PARAM_TRADE_IN];
};

/**
 * Get trade in from tariff setting
 *
 */
export const getTradeInFromTariff = (): boolean => {
    const storage = getSessionStorage(SAILS_BNT_STORAGE);

    return storage[APP]?.[CONTAINER_TARIFF]?.[SAILS_PARAM_TRADE_IN] || false;
};
